import React from "react"
import TransferImg from "../../../../../assets/avia/sidebar/terminal.png"

const Transfers = ({ transfers, setTransfers }) => {
  return (
    <div className="mb-6 relative">
      <div className="flex items-center mb-2 gap-1">
        <img src={TransferImg} alt="terminal icon" className="w-6 h-6" />
        <span className="text-dark-gray text-lg">Пересадки</span>
      </div>

      <div className="space-y-1 px-0.5">
        {Object.entries(transfers).map(([key, value]) => (
          <CheckBox
            key={key}
            checked={value.checked}
            label={value.label}
            onChange={(e) =>
              setTransfers((prev) => ({
                ...prev,
                [key]: {
                  ...prev[key],
                  checked: e.target.checked,
                },
              }))
            }
          />
        ))}
      </div>
      <div className="absolute -bottom-3 left-0 right-0 border-b  border-light-gray/25"></div>
    </div>
  )
}

export default Transfers

const CheckBox = ({ label, checked, onChange }) => (
  <label className="flex items-center justify-between  cursor-pointer">
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className=" cursor-pointer
            w-4 h-4
            border-gray-300 rounded
            accent-green-600
            checked:bg-green-600
            checked:border-green-600
            focus:ring-green-500
          "
      />
      <span className="ml-2 text-[15px] text-gray-700">{label}</span>
    </div>
    <p className="text-sm">
      <span>от</span> <span className="text-orange-500">80€</span>
    </p>
  </label>
)
